"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.css = css;
exports.responsiveValueToRangeMap = responsiveValueToRangeMap;
exports.responsiveValueToResponsiveSize = responsiveValueToResponsiveSize;
exports.responsiveValueCurrent = responsiveValueCurrent;
exports.useResponsiveHelpers = useResponsiveHelpers;
exports.responsiveValueTransformScales = responsiveValueTransformScales;
exports.buildComponent = buildComponent;
exports.jsx = jsx;
exports.rs = rs;
exports.rslin = rslin;
exports.getElementSpec = getElementSpec;
exports.createElement = createElement;
exports.splitSx = splitSx;
exports.responsiveValueMap = responsiveValueMap;
exports.responsiveValueForEach = responsiveValueForEach;
exports.createComponent = exports.lin = exports.css2 = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _css2 = _interopRequireWildcard(require("./css"));

var _Theme = require("./Theme");

var _responsiveHelpers = require("responsive-helpers");

var __jsx = _react["default"].createElement;

// import { R}
// import { rs as rs_, rslin as rslin_ } from "responsive-helpers";
function rs(config) {
  return config;
}

function rslin(from, to, isInf) {
  return {
    from: from,
    to: to,
    isInf: isInf,
    __isLinear: true
  };
}

var lin = rslin;
/**
 * Let's just add:
 * - responsive helpers to take theme breakpoints into account
 * - extension that allows to add
 */

exports.lin = lin;

function css(styles) {
  styles = (0, _isArray["default"])(styles) ? styles : [styles]; // we can have multiple styles
  // console.log('before css flattened styles', styles);

  styles = styles.flat([100]);
  styles = styles.filter(function (x) {
    return !!x;
  }); // console.log('after css flattened styles', styles);

  return function (theme) {
    return styles.map(function (stylesSet) {
      return (0, _css2["default"])(stylesSet)(theme);
    });
  };
}

var css2 = _css2["default"];
exports.css2 = css2;

function jsx(type, props) {
  var newProps = (0, _objectSpread2["default"])({}, props);
  var createElement = _react["default"].createElement;

  if (typeof type === "string" && props && props.sx) {
    // const [_css, _] = splitSx(props.sx); // for primitive components we ignore custom sx and just extract CSS to pass it through emotion "css" prop
    newProps.css = css(props.sx); //theme => { return css(props.sx, theme) }

    delete newProps.sx;
    createElement = _core.jsx;
  }

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return createElement.apply(void 0, [type, newProps].concat(children));
}

function mergeCss(a, b) {
  var ret = [];

  if ((0, _isArray["default"])(a)) {
    ret = (0, _toConsumableArray2["default"])(a);
  } else {
    ret = [a];
  }

  if ((0, _isArray["default"])(b)) {
    ret = [].concat((0, _toConsumableArray2["default"])(ret), (0, _toConsumableArray2["default"])(b));
  } else {
    ret = [].concat((0, _toConsumableArray2["default"])(ret), [b]);
  }

  return ret;
}

function getElementSpec() {
  var childSpec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentSpec = arguments.length > 1 ? arguments[1] : undefined;
  var state = arguments.length > 2 ? arguments[2] : undefined;
  var forcedProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  childSpec = typeof childSpec === "function" ? childSpec(state) : childSpec;
  parentSpec = typeof parentSpec === "function" ? parentSpec(state) : parentSpec;
  forcedProps = typeof forcedProps === "function" ? forcedProps(state) : forcedProps;
  var parentSx = (0, _objectSpread2["default"])({}, parentSpec);
  delete parentSx.__children;
  delete parentSx.__type;
  delete parentSx.__props;
  var childSx = (0, _objectSpread2["default"])({}, childSpec);
  delete childSx.__children;
  delete childSx.__type;
  delete childSx.__props;

  var _splitSx = splitSx(parentSx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      parentCss = _splitSx2[0],
      parentCustomSx = _splitSx2[1];

  var _splitSx3 = splitSx(childSx),
      _splitSx4 = (0, _slicedToArray2["default"])(_splitSx3, 2),
      childCss = _splitSx4[0],
      childCustomSx = _splitSx4[1]; //
  // console.log('parent css', parentCss);
  // console.log('child css', childCss);
  //
  // console.log('---- ', [parentSx.$css, parentCss, childSx.$css, childCss]);


  return (0, _objectSpread2["default"])({}, parentCustomSx, childCustomSx, {
    $css: [parentSx.$css, parentCss, childSx.$css, childCss],
    __props: (0, _objectSpread2["default"])({}, parentSpec.__props, childSpec.__props, forcedProps),
    __children: childSpec.__children || parentSpec.__children,
    __type: childSpec.__type || parentSpec.__type
  });
}

function createElement(spec) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var __type = spec.__type,
      __children = spec.__children,
      __props = spec.__props,
      sx = (0, _objectWithoutProperties2["default"])(spec, ["__type", "__children", "__props"]);

  if (!__type || typeof __type === "string") {
    // If primitive element, then we should extract $css and sx should be an array.
    var _splitSx5 = splitSx(sx),
        _splitSx6 = (0, _slicedToArray2["default"])(_splitSx5, 2),
        _css = _splitSx6[0],
        $css = _splitSx6[1].$css;

    return jsx(__type || "div", (0, _objectSpread2["default"])({
      sx: [_css, $css]
    }, __props, props), __children);
  }

  return jsx(__type, (0, _objectSpread2["default"])({
    sx: sx
  }, __props, props), __children);
}

function splitSx(sx) {
  var css = {};
  var customSx = {};

  if ((0, _isArray["default"])(sx)) {
    customSx.$css = [];
    sx.forEach(function (subSx) {
      var _splitSx7 = splitSx(subSx),
          _splitSx8 = (0, _slicedToArray2["default"])(_splitSx7, 2),
          css_ = _splitSx8[0],
          sx_ = _splitSx8[1];

      customSx.$css.push(css_);
      customSx = (0, _objectSpread2["default"])({}, customSx, sx_);
    });
  } else {
    for (var prop in sx) {
      if (prop.startsWith("$")) {
        customSx[prop] = sx[prop];
      } else {
        css[prop] = sx[prop];
      }
    }
  }

  if (customSx.$css) {
    css = [customSx.$css, css];
    delete customSx.$css;
  }

  return [css, customSx];
} //
// function responsiveValueGetValueForBreakpoint(value, breakpoint) {
//   const theme = useTheme();
//
//   if (typeof value === 'string') {
//     const potentialValueFromTheme = get(theme.space || {}, value);
//     if (potentialValueFromTheme) {
//       value = potentialValueFromTheme;
//     }
//   }
// }


function responsiveValueForEach(resVal, callback, theme) {
  if (!theme) {
    theme = (0, _Theme.useTheme)();
  }

  var _theme = theme,
      breakpoints = _theme.breakpoints;

  if ((0, _isArray["default"])(resVal)) {
    resVal.forEach(function (val, index) {
      if (val === null) return;

      if (index === 0) {
        callback(val, null);
        return;
      }

      callback(val, breakpoints[index - 1]);
    });
    return;
  } else if (typeof resVal === "object" && typeof resVal._ !== "undefined") {
    for (var key in resVal) {
      if (key === "_") {
        callback(resVal[key], null);
        continue;
      }

      if (!breakpoints[key]) {
        throw new Error("Non-existent breakpoint");
      }

      callback(resVal[key], breakpoints[key]);
    }

    return;
  }

  callback(resVal, null);
}

function responsiveValueMap(resVal, mapper, theme) {
  if (!theme) {
    theme = (0, _Theme.useTheme)();
  }

  var _theme2 = theme,
      breakpoints = _theme2.breakpoints;

  if ((0, _isArray["default"])(resVal)) {
    var newResVal = [];

    for (var index in resVal) {
      if (resVal[index] === null) {
        newResVal.push(null);
        continue;
      }

      newResVal.push(mapper(resVal[index]));
    }

    return newResVal;
  } else if (typeof resVal === "object") {
    var _newResVal = {};

    for (var key in resVal) {
      _newResVal[key] = mapper(resVal[key]);
    }

    return _newResVal;
  }

  return mapper(resVal);
}
/**
 * ARITHMETICS ON RESPONSIVE ARRAYS
 */


function castResponsiveValue(resVal, Type, scale) {
  var theme = (0, _Theme.useTheme)(); // if (scale) {
  //   scale = theme[scale] || {};
  // }

  var config = {};
  responsiveValueForEach(resVal, function (val, breakpoint) {
    //
    // if (scale && typeof val === 'string') {
    //   const potentialValueFromTheme = get(scale, val);
    //
    //   console.log('potential value', potentialValueFromTheme, 'from', val);
    //   if (potentialValueFromTheme) {
    //     val = potentialValueFromTheme;
    //   }
    //   // console.log('before', val, 'after', val2)
    //
    // }
    if (breakpoint === null) {
      config[0] = val;
    } else {
      config[(0, _parseInt2["default"])(breakpoint)] = val;
    }
  });
  return new Type(config);
}

function responsiveValueToRangeMap(resVal) {
  return castResponsiveValue(resVal, _responsiveHelpers.RangeMap);
}

function responsiveValueToResponsiveSize(resVal) {
  return castResponsiveValue(resVal, _responsiveHelpers.ResponsiveSize, "space");
}

function responsiveValueCurrent(resVal, theme) {
  if (typeof window !== "object") {
    return;
  }

  var activeVal;
  responsiveValueForEach(resVal, function (val, breakpoint) {
    if (!breakpoint) {
      activeVal = val;
      return;
    }

    if (window.matchMedia("screen and (min-width: ".concat(breakpoint, ")")).matches) {
      activeVal = val;
    }
  }, theme);
  return activeVal;
}

function useResponsiveHelpers() {
  var theme = (0, _Theme.useTheme)();
  return {
    currentValue: function currentValue(resVal) {
      return responsiveValueCurrent(resVal, theme);
    }
  };
} // Helper for quick creating of components


var createComponent = function createComponent(Component, newSx) {
  return function (_ref) {
    var sx = _ref.sx,
        restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx"]);

    var _splitSx9 = splitSx(sx),
        _splitSx10 = (0, _slicedToArray2["default"])(_splitSx9, 2),
        css = _splitSx10[0],
        customSx = _splitSx10[1];

    var newSx2 = typeof newSx === "function" ? newSx(customSx) : newSx;
    var newSx3;

    if (typeof newSx2 === "function") {
      newSx3 = function newSx3() {
        return (0, _objectSpread2["default"])({}, newSx2.apply(void 0, arguments), sx, {
          $css: css
        });
      };
    } else {
      newSx3 = (0, _objectSpread2["default"])({}, newSx2, sx, {
        $css: css
      });
    }

    return __jsx(Component, (0, _extends2["default"])({}, restProps, {
      sx: newSx3
    }));
  };
};

exports.createComponent = createComponent;

function responsiveValueTransformScales(value, theme, scale, mainScale) {
  if ((0, _isArray["default"])(value)) {
    return value.map(function (v) {
      return responsiveValueTransformScales(v, theme, scale, mainScale);
    });
  } else if (typeof value === "object" && value !== null) {
    var newObj = {};

    for (var key in value) {
      newObj[key] = responsiveValueTransformScales(value[key], theme, scale, mainScale);
    }

    return newObj;
  } else if (typeof value === "string") {
    var _key2 = "".concat(scale, ".").concat(value);

    var transformedVal = (0, _css2.get)(theme, "".concat(mainScale, ".").concat(_key2));

    if (transformedVal) {
      return _key2;
    }

    return value;
  }

  return value;
}

function buildComponent(component, arg) {
  if (_react["default"].isValidElement(arg)) {
    return _react["default"].cloneElement(arg, (0, _objectSpread2["default"])({}, component.props, arg.props, {
      sx: (0, _objectSpread2["default"])({}, component.props.sx, arg.props.sx)
    }));
  } else if (typeof arg === "object") {
    return _react["default"].cloneElement(component, {
      sx: (0, _objectSpread2["default"])({}, component.props.sx, arg)
    });
  } else if (!arg) {
    return component;
  }

  throw new Error("Bad input for createBox");
} //
// function superResponsive(val, dict = {}) {
//   return responsiveValueMap(val, (x, breakpoint) => {
//     console.log(x, breakpoint);
//     return typeof dict[x] === 'undefined' ? x : dict[x];
//   })
// }